import { createApp, markRaw } from 'vue'
import { createPinia } from 'pinia'
import VueTippy from 'vue-tippy'
import VClickOutside from 'click-outside-vue3'
import Notifications from '@kyvg/vue3-notification'
import CountryFlag from 'vue-country-flag-next'
import Vue3TouchEvents from 'vue3-touch-events'
import router from '@/router'
import App from '@/App.vue'
import vEsc from '@/directives/v-esc'

import '@/assets/main.css'

const pinia = createPinia()

const app = createApp(App)

app.directive('esc', vEsc)

pinia.use(({ store }) => {
    store.router = markRaw(router)
})

app.use(pinia)
app.use(router)
app.use(VClickOutside)
app.use(Notifications)
app.use(CountryFlag)
app.use(
    VueTippy,
    {
        directive: 'tippy', // => v-tippy
        component: 'tippy', // => <tippy/>
        componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
        defaultProps: {
            theme: 'dark',
            placement: 'auto-end',
            allowHTML: true,
            delay: 0,
            arrow: false,
            hideOnClick: false,
            touch: false,
            // trigger: 'click',
            offset: [0, 12],
            maxWidth: 'none',
        },
    },
)
app.use(Vue3TouchEvents)
app.mount('#app')
